export default __webpack_public_path__ + "static/woman-coffee-651b019d48d7a4f422400e5c7e78cd1b.jpg";